import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberResearchProjects } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberResearchProjects } from "@/api/members/researchProjects/getAll";
import { useGetMemberResearchProject } from "@/api/members/researchProjects/get";

const { getPath } = getApi("members.researchProject.post");

type IExtractedRouteType =
  IMemberResearchProjects["researchProjectSingleCreate"];

export type IPostMemberResearchProject = IPickMutation<IExtractedRouteType>;

const postMemberResearchProject: MutationFunction<
  IPostMemberResearchProject["response"],
  IPostMemberResearchProject["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberResearchProject = createMutation({
  mutationFn: postMemberResearchProject,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberResearchProjects.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberResearchProject.getKey({ memberId }),
    });
  },
});
